import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ApplicationCreationSources } from '../../shared/enums';
import { Lead } from '../../shared/models/login/lead.model';
import { LoginDetails } from '../../shared/models/login/login-details.model';
import { LoginVerification } from '../../shared/models/login/login-verification.model';
import { AuthService } from '../../shared/services/auth/auth.service';
import { EncryptionService } from '../../shared/services/auth/encryption.service';
import { DialogService } from '../../shared/services/common/dialog/dialog.service';
import { LocalStoreService } from '../../shared/services/common/local-store/local-store.service';

declare var $: any;

@Component({
	selector: 'app-open-trading-account2',
	templateUrl: './open-trading-account2.component.html',
	styleUrls: ['./open-trading-account2.component.scss']
})
export class OpenTradingAccount2Component implements OnInit {

	lead: Lead = new Lead();
	loginDetails: LoginDetails = new LoginDetails();

	get data(): LoginVerification {
		return this.localStore.data;
	}

	callInProgress: boolean = false;

	constructor(
		private authService: AuthService,
		private localStore: LocalStoreService,
		private router: Router,
		private route: ActivatedRoute,
		private dialogService: DialogService,
		private encryption: EncryptionService
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
	}

	ngOnInit(): void {
		const me = this;

		$(window).scroll(function () {
			if ($(this).scrollTop() > 500) {
				$('#inp-fixed').addClass('inp-fixed-sec');
			} else {
				$('#inp-fixed').removeClass('inp-fixed-sec');
			}
		});


		this.localStore.reset();

		//Read UTM Parameters
		this.route.queryParams.subscribe(params => {
			me.localStore.saveUtmParams(params);
		});
	}

	doLogin() {
		if (!this.loginDetails.Mobile || this.loginDetails.Mobile.length !== 10) {
			this.dialogService.error("Please enter 10 digit mobile number.");
			return;
		}

		this.lead = new Lead();
		this.lead.Mobile = this.encryption.RSAEncrypt(this.loginDetails.Mobile);
		this.lead.LeadSource = "LP";
		this.lead.UtmSource = this.localStore.data.UtmSource;
		this.lead.UtmTerm = this.localStore.data.UtmTerm;
		this.lead.UtmMedium = this.localStore.data.UtmMedium;
		this.lead.UtmCampaign = this.localStore.data.UtmCampaign;
		this.lead.UtmContent = this.localStore.data.UtmContent;
		this.lead.UtmPromo = this.localStore.data.UtmPromo;
		this.lead.UtmDeviceId = this.localStore.data.UtmDeviceId;
		this.lead.UtmAppid = this.localStore.data.UtmAppid;
		this.lead.UtmAdvertisementId = this.localStore.data.UtmAdvertisementId;
		this.lead.UtmAppsflyerid = this.localStore.data.UtmAppsflyerid;
		this.lead.UtmOSversion = this.localStore.data.UtmOSversion;
		this.lead.UtmATTConsent = this.localStore.data.UtmATTConsent;
		this.lead.LgCode = this.localStore.data.LgCode;
		this.lead.LcCode = this.localStore.data.LcCode;
		this.lead.SourceCode = this.localStore.data.SourceCode;
		this.lead.Source = ApplicationCreationSources.HSLDAO;

		if (this.callInProgress) return;

		this.callInProgress = true;

		this.lead.AppExists = undefined;
		this.lead.SnklRefId = undefined;

		this.authService.doLoginLp(this.lead).subscribe(response => {
			this.postLogin(response);
		}, () => this.callInProgress = false, () => this.callInProgress = false);
	}

	postLogin(response: LoginDetails) {
		this.localStore.data = this.data;
		this.localStore.data.Mobile = this.loginDetails.Mobile;
		this.localStore.data.LeadId = response.LeadId;
		this.localStore.data.AppExists = response.AppExists;
		this.localStore.data.SnklRefId = response.SnklRefId;
		this.localStore.saveData();
		window.location.href = "/login-lp";
	}
}
